export const benchmarkConstants = {
  TITLE: 'CMS Benchmarking',
  SUBTITLE:
    'This view benchmarks only procedures where a CMS rate is available (CLFS, ASP, MPFS). Other lines within the same claim are not benchmarked, so benchmarked spend will be lower than total medical spend',
  CARDS: {
    CARD1_TITLE: 'Benchmarked Spend',
    CARD1_SUBTITLE: 'of medical spend with a CMS benchmark',
    CARD2_TITLE: 'Avg Rate vs CMS (Weighted)',
    CARD2_SUBTITLE: 'claim lines mapped to CMS benchmark',
    CARD3_TITLE: '% of Benchmarked Spend > 150% of CMS',
    CARD3_SUBTITLE: 'of benchmarked spend paid above 150% of CMS',
  },
  TABLE: 'Benchmark Categories',
  TABLE_INTERNAL: 'List of Procedures',
  ERROR: 'Error fetching categories',
  COLUMNS: {
    BENCHMARK_SPEND: {
      label: 'Benchmarked Spend ($)',
      description:
        'Total dollars for claims in this category that were successfully matched to a CMS benchmark.',
    },
    BENCHMARK_CLAIM_COUNT: {
      label: 'Benchmarked Claim Count',
      description:
        'Number of claim lines included in the benchmarked analysis for this category.',
    },
    AVG_RATE_VS_CMS_WEIGHTED: {
      label: 'Avg Rate vs CMS (Weighted)',
      description:
        'Average price paid compared to CMS, weighted by claim dollars (e.g., 125% = 25% above CMS).',
    },
    PERCENT_SPEND_OVER_150_CMS: {
      label: '% Spend > 150% of CMS',
      description:
        'Percentage of claims line for which services are priced more than 150% of the CMS benchmark.',
    },
    TOP_HIGH_IMPACT_COST_DRIVERS: {
      label: 'Top High-Impact Cost Drivers (% of CMS)',
      description:
        'Services that are both heavily used and priced well above CMS benchmarks, representing the biggest cost and savings opportunities. Shown as top codes with rate of CMS.',
    },
  },
  INTERNAL_COLUMNS: {
    PROCEDURE_DRUG_CODE: {
      label: 'Procedure/ Drug Code',
      description:
        'Billing code for the service or drug (CPT, HCPCS, J-code, or NDC).',
    },
    PROCEDURE_DRUG_DESCRIPTION: {
      label: 'Procedure/ Drug Description',
      description: 'Name of the billed service or medication.',
    },
    CLAIM_COUNT: {
      label: 'Claim Count',
      description: 'Number of claim lines for this service or drug.',
    },
    TOTAL_UNITS: {
      label: 'Total Units',
      description:
        'Total number of units billed for this service or drug across all claims.',
    },
    PAID_AMOUNT: {
      label: 'Paid Amount ($)',
      description:
        'Total amount paid for this service or drug in the selected period.',
    },
    PAID_AMOUNT_PER_UNIT: {
      label: 'Paid Amount Per Unit ($)',
      description: 'Average amount paid per unit for this service or drug.',
    },
    CMS_BENCHMARKED_AMOUNT: {
      label: 'CMS Benchmarked Amount ($)',
      description:
        'Total amount this service or drug would cost if priced at the CMS benchmark rate.',
    },
    CMS_BENCHMARKED_AMOUNT_PER_UNIT: {
      label: 'CMS Benchmarked Amount Per Unit ($)',
      description: 'CMS benchmark rate per unit for this service or drug.',
    },
    AVG_RATE_VS_CMS: {
      label: 'Avg Rate vs CMS',
      description:
        'Ratio of Paid Amount to CMS Benchmarked Amount (e.g., 140% = 40% above CMS).',
    },
  },
};
